import { IUser } from './components/user_context_provider';

export function userHasGivenFullPrivacyConsent(user: Partial<IUser>): boolean {
  return user.thirdPartyAdDataAllowed && user.thirdPartyAdStorageAllowed && user.thirdPartyAdPersonalizationAllowed && user.thirdPartyAnalyticsStorageAllowed;
}
